import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

import { AgGridReact } from "ag-grid-react";

import { logout } from "../../utils";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css";
import { makeCygnusApiCall } from "../../api/api";
import { CustomButton } from "../../reusable-components/CustomButtonComponent/button";


const FirmJobs = () => {
  const [firmJobs, setFirmJobs] = useState([]);
  const [dataSource, setDataSource] = useState(null);
  const [editedRows, setEditedRows] = useState([]);

  const vendorDetailsGridRef = useRef();
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "73vh", width: "100%" }), []);
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      animateRows: true,
    }),
    []
  );
  const onFirstDataRendered = useCallback((params) => {
    vendorDetailsGridRef.current.api.sizeColumnsToFit();
  }, []);

  // Get all firm jobs
  useEffect(() => {
    const getJobs = async () => {
      const data = await makeCygnusApiCall({
        type: "GET",
        payload: {},
        url: "/firm_jobs/",
        show_message: false,
        customized_success_message: "Successfully fetched your firm jobs data",
        customized_failure_message: "Unable to fetch your firm jobs data, please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while fetching your firm jobs data, please contact support and attach a screenshot.",
        isblob: false
      })
      if (data.success) {
        data = data["Data"].map((el) => {
          el.Active = el.Active == "Y" ? "True" : "False";
          return el;
        });
        setFirmJobs(data);
      }
    }
    getJobs()
  }, []);

  const simpleComp = (p) => {
    return <>{p.value}</>;
  };

  const [columnDefs, setColumnDefs] = useState([
    { field: "FirmId", hide: true },
    { field: "FirmJobId" },
    { field: "FrequencyInterval", editable: true },
    {
      field: "FrequencyUnit",
      cellEditor: "agSelectCellEditor",
      editable: true,
      cellEditorParams: {
        values: ["MIN", "HOUR", "DAY"],
      },
    },
    { field: "JobDescription" },
    { field: "JobName" },
    { field: "LastRunDatetime" },
    { field: "ServiceName" },
    { field: "Status" },
    {
      field: "Active",
      cellEditor: "agSelectCellEditor",
      editable: true,
      cellEditorParams: {
        values: ["True", "False"],
      },
    },
  ]);

  const sortable = true;
  const filter = true;
  const resizable = true;

  const onCellValueChanged = (item) => {
    item.node.data["changed"] = true;
  };

  const onCellEditingStopped = (event) => {
    setEditedRows([...editedRows, event.rowIndex]);
  };

  const [apiProgressFlag, setApiProgressFlag] = useState()
  const getAllRows = async () => {
    setApiProgressFlag(true)

    // let rowData = [];
    // editedRows &&
    //   vendorDetailsGridRef &&
    //   vendorDetailsGridRef.current &&
    //   vendorDetailsGridRef.current.api.forEachNode((node) => {
    //     if (editedRows.includes(node.rowIndex)) {
    //       rowData.push(node.data);
    //     }
    //   });

    const changedRowsFirmJobs = [];

    vendorDetailsGridRef.current.api.forEachNode((node) => {
      if (node.data.changed) {
        changedRowsFirmJobs.push(node.data);
      }
    });

    const mappedRowData =
      changedRowsFirmJobs &&
      changedRowsFirmJobs.map((el) => {
        return {
          FirmJobId: el.FirmJobId,
          FrequencyInterval: el.FrequencyInterval,
          FrequencyUnit: el.FrequencyUnit,
          Active: el.Active == "True" ? "Y" : "N",
        };
      });
    const _ = await makeCygnusApiCall({
      type: "POST",
      payload: mappedRowData,
      url: "/firm_jobs/",
      show_message: false,
      customized_success_message: "Successfully saved your firm jobs data",
      customized_failure_message: "Unable to fetch your firm jobs data, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while fetching your firm jobs data, please contact support and attach a screenshot.",
      isblob: false
    })
    setApiProgressFlag(false)
    return changedRowsFirmJobs;
  };

  let contextGridApi;
  const onContextGridReady = useCallback((params) => {
    contextGridApi = params.api
    contextGridApi.closeToolPanel();
  })

  return (
    <Container fluid>
      <Row>
        {/* <Col md={2}></Col> */}
        <Col xs={12} >
          <h2 className="display-6">Firm Jobs</h2>

          {firmJobs && (
            <div style={containerStyle}>
              <Row>
                <Col xs={11}></Col>
                <Col xs={1} style={{ padding: 0 }}>
                  <CustomButton
                    progress={apiProgressFlag}
                    onclick={() => getAllRows()}
                    content={apiProgressFlag ? "Saving" : "Save"}
                    disable={apiProgressFlag}
                  />
                </Col>
              </Row>
              <div className="cross-reference-grid">
                <div className="ag-theme-balham" style={gridStyle}>
                  <AgGridReact
                    ref={vendorDetailsGridRef}
                    rowData={firmJobs}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    onGridReady={onContextGridReady}
                    sideBar={"columns"}
                    sortable={sortable}
                    filter={filter}
                    resizable={resizable}
                    alwaysShowHorizontalScroll={true}
                    alwaysShowVerticalScroll={true}
                    onFirstDataRendered={onFirstDataRendered}
                    rowHeight={40}
                    onCellValueChanged={(item) => onCellValueChanged(item)}
                    onCellEditingStopped={(event) => onCellEditingStopped(event)}
                  />
                </div>
              </div>
            </div>
          )}
        </Col>
        {/* <Col md={2}></Col> */}
      </Row>
    </Container>
  );
};

export default FirmJobs;
